export type LivekitIngressType = 'whip' | 'rtmp' | 'srt';

/**
 * Onsite location input types backed by a LiveKit ingress. Excludes 'srt' — an onsite
 * location's SRT input is the standalone SRT service (srtStreams), not a LiveKit SRT
 * ingress, so it renders and mutes through a different path entirely.
 */
export type LivekitIngressInputType = Extract<LivekitIngressType, 'whip' | 'rtmp'>;

export const LIVEKIT_INGRESS_INPUT_LABELS: Record<LivekitIngressInputType, string> = {
	whip: 'WHIP',
	rtmp: 'RTMP',
};

export const isLivekitIngressInputType = (
	inputType?: string | null,
): inputType is LivekitIngressInputType => inputType === 'whip' || inputType === 'rtmp';

export interface LivekitIngress {
	id: string;
	type: LivekitIngressType;
	endpoint: string;
	streamKey?: string;
	participantIdentity: string;
	locationId?: number;
	volume: number;
	muted: boolean;
	videoMuted: boolean;
}

export interface LivekitSession {
	meetingId: number;
	status: string;
	createdAt: number;
}

export interface LivekitState {
	livekitSession: LivekitSession | null;
	livekitIngresses: LivekitIngress[];
}
